import { Injectable, inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MobileTanComponent } from "./mobile-tan/mobile-tan.component";

@Injectable({
  providedIn: "root"
})
export class MobileTanService {
  private readonly dialog = inject(MatDialog);

  openDialog(): void {
    this.dialog.open(MobileTanComponent, {
      autoFocus: true
    });
  }
}
